
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Lieu from '@/extend/classes/Lieu';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeLieu' })

export default class storeLieu extends VuexModule {
  // States
  private reccords: Lieu[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get lieuLoading (): boolean {
    return this.dataLoading;
  }
  private get lieuRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get lieuLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewLieu() {
    return (): Lieu => { 
      return this.getLieu(0, true);
    }
  }

  
  public get getLieu () {
    return (id: number, canCreate = false): Lieu => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Lieu can't be 0")
        return new Lieu();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Lieu();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Lieu.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromLieu(data.reccords[0] as Lieu);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listLieu (): Lieu[] {
    return this.reccords;
  }

  public get listConfigLieu (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mLieuRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mLieuClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mLieuLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mLieuLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Lieu.fromJson(reccord as Lieu));
    })
    Lieu.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mLieuConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mLieuCreated (obj: Lieu): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareLieu(obj)) {
          api.fromLieu(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareLieu(obj)) {
            api.fromLieu(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mLieuUpdated (obj: Lieu): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareLieu(obj)) {
          api.fromLieu(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mLieuDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerLieu (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.lieuRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerLieu(this.lieuCreated, this.lieuUpdated, this.lieuDeleted);
          this.mLieuRegistered();
        } else {
          setTimeout(() => resolve(this.registerLieu(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.lieuLoading && !this.lieuLoaded) {
          this.mLieuLoading(true);
          return Lieu.list(filter)
            .then((data: ListData) => {
              this.mLieuLoaded(data);
              this.mLieuLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredLieu (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.lieuLoading) {
        this.mLieuLoading(true);
        return Lieu.list(filter)
          .then((data: ListData) => {
            this.mLieuLoaded(data);
            this.mLieuLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createLieu (obj: Lieu): Promise<Lieu> {
    return new Promise((resolve, reject) => {
      return Lieu.fromJson(obj).createForStoreLieu()
        .then((reccords) => {
          this.mLieuCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateLieu (obj: Lieu): Promise<Lieu> {
    return new Promise((resolve, reject) => {
      return Lieu.fromJson(obj).updateForStoreLieu()
        .then((reccords) => {
          this.mLieuUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteLieu (obj: Lieu): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Lieu.fromJson(obj).deleteForStoreLieu()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mLieuDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private lieuCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mLieuConfigUpdated(config)
    const obj = objConfig.obj as Lieu;
    this.mLieuCreated(Lieu.fromJson(obj));
  }

  @Action
  private lieuUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mLieuConfigUpdated(config)
    const obj = objConfig.obj as Lieu;
    this.mLieuUpdated(Lieu.fromJson(obj));
  }

  @Action
  private lieuDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Lieu;
    this.mLieuDeleted(obj.id);
  }
}
